import { DEPOSITORY_CONTENT_SERVICE_NAME, DepositoryContentServiceProvider } from './depository.content.service'
import { DEPOSITORY_CONTEXT_MENU_SERVICE_NAME, DepositoryContextMenuServiceProvider } from './depository.context-menu.service'
import { DEPOSITORY_MIN_STATES_SERVICE_NAME, DepositoryMinStatesServiceProvider } from './depository.min-states.service'
import { DEPOSITORY_SERVICE_NAME, DepositoryServiceProvider } from './depository.service'

export const DEPOSITORY_SERVICES_MODULE_NAME = 'simax.services.depository'

const module = angular.module(DEPOSITORY_SERVICES_MODULE_NAME, [])

module.provider(DEPOSITORY_CONTENT_SERVICE_NAME, DepositoryContentServiceProvider)
module.provider(DEPOSITORY_CONTEXT_MENU_SERVICE_NAME, DepositoryContextMenuServiceProvider)
module.provider(DEPOSITORY_MIN_STATES_SERVICE_NAME, DepositoryMinStatesServiceProvider)
module.provider(DEPOSITORY_SERVICE_NAME, DepositoryServiceProvider)
